import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NutshelltoOfficeRegular from './nutshellto-office-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <NutshelltoOfficeRegular {...validProps} />;
}
SvgComponent.iconName = 'nutshelltoOfficeRegular';

export const NutshelltoOfficeRegularIcon = svgIconWrapper(SvgComponent);
